const collator = new Intl.Collator('en', { numeric: true, sensitivity: 'base' });

export const sortByLastNameFirstName = <T extends { firstName?: string; lastName?: string }>(a: T, b: T) =>
  collator.compare(a.lastName ?? '', b.lastName ?? '') || collator.compare(a.firstName ?? '', b.firstName ?? '');
